namespace TabAurous.Finance {
    export interface AccountingPeriodDetailsForm {
        PeriodId: Serenity.IntegerEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        IsClosed: Serenity.BooleanEditor;
    }

    export class AccountingPeriodDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.AccountingPeriodDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountingPeriodDetailsForm.init)  {
                AccountingPeriodDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(AccountingPeriodDetailsForm, [
                    'PeriodId', w0,
                    'VoucherTypeId', w0,
                    'CompanyId', w0,
                    'IsClosed', w1
                ]);
            }
        }
    }
}
